var isEmpty = require('./isEmpty');

module.exports = function isFalse(obj){
	return isEmpty(obj);
}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isFalse.js
 ** module id = 30
 ** module chunks = 0
 **/